import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './Home'
import HomeTwo from './HomeTwo'
import HomeThree from './HomeThree'
import HomeFour from './HomeFour'
function RouterPage() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/home-two" element={<HomeTwo />}></Route>
          <Route path="/home-three" element={<HomeThree />}></Route>
          <Route path="/home-four" element={<HomeFour />}></Route>
        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage